import { FEAASElement } from './FEAASElement.js';
export default class FEAASReactElement extends FEAASElement {
    load() {
        return Promise.all([
            // @ts-ignore @webpack-ignore
            import('https://cdn.skypack.dev/react'),
            // @ts-ignore
            import('https://cdn.skypack.dev/react-dom'),
            // @ts-ignore
            import('https://cdn.skypack.dev/react-dom/client')
        ]).then(([React, ReactDOM, ReactDOMClient]) => {
            return { React, ReactDOM, ReactDOMClient };
        });
    }
    render({}, { React }) {
        return React.createElement(React.Fragment, null);
    }
}
export class MyComponent extends FEAASReactElement {
    constructor() {
        super(...arguments);
        this.useShadowRoot = true;
    }
    // parse attributes from web component to react-ready form
    getProps() {
        return {
            counter: parseFloat(this.getAttribute('counter'))
        };
    }
    // First argument is props, second arguments is React stuff
    // Destructuring React is important for JSX to work
    render({ counter }, { React }) {
        const [updates, setUpdates] = React.useState(0);
        React.useEffect(() => {
            setUpdates((u) => u + 1);
        }, [counter]);
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Rendering attribute: ",
                counter),
            React.createElement("p", null,
                "Triggered updates: ",
                updates)));
    }
}
// will re-render component if any of these attributes have changed
MyComponent.observedAttributes = ['counter'];
//# sourceMappingURL=FEAASReactElement.js.map